/** @format */

import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

import {
  fullYears,
  EducationData,
  profielUpdateAllowedFilelds,
} from "utils/constant.data";
import { useUpdateFellowProfileMutation } from "store/services/adminAPI";
import {
  extractErrorMessage,
  replaceUnderscoresWithSpaces,
  GraduationClassOptions,
  levels,
  EnglishProficiencyLevelOptions,
  capitalize,
} from "utils/strings";
import { options } from "utils/constant.data";
import { Fragment } from "react";

const Education = ({ currentProfile, setActiveTab }) => {
  const [updateFellowProfile, { isLoading: updating }] =
    useUpdateFellowProfileMutation();

  // const handleSubmit = async (values) => {
  //   let profileData = {
  //     educational_institution_attended: values.educational_institution_attended,
  //     level_of_education: values.level_of_education,
  //     field_of_study: values.field_of_study,
  //     graduation_year: values.graduation_year,
  //     technical_skill_level: values.technical_skill_level,
  //     graduation_class: values.graduation_class,
  //     cv: values.cv,
  //     linkedin_url: values.linkedin_url,
  //     english_proficiency: values.english_proficiency,
  //     other_languages: values.other_languages,
  //     has_completed_nysc: values?.has_completed_nysc,
  //   };

  //   if (values.has_completed_nysc) {
  //     profileData = {
  //       educational_institution_attended:
  //         values.educational_institution_attended,
  //       level_of_education: values.level_of_education,
  //       field_of_study: values.field_of_study,
  //       graduation_year: values.graduation_year,
  //       technical_skill_level: values.technical_skill_level,
  //       graduation_class: values.graduation_class,
  //       cv: values.cv,
  //       linkedin_url: values.linkedin_url,
  //       english_proficiency: values.english_proficiency,
  //       other_languages: values.other_languages,
  //       has_completed_nysc: values?.has_completed_nysc,
  //       nysc_completion_year: values?.nysc_completion_year,
  //       nysc_certificate: values?.nysc_certificate,
  //       nysc_certificate_number: values?.nysc_certificate_number,
  //       nysc_call_up_number: values?.nysc_call_up_number,
  //     };
  //   }

  //   await updateFellowProfile(profileData)
  //     .unwrap()
  //     .then((data) => {
  //       const message = `✔️ Profile updated !`;
  //       toast.success(message, {
  //         position: "top-right",
  //         autoClose: 2500,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //       });
  //       setActiveTab("professional");
  //     })
  //     .catch((error) => {
  //       const formattedError = extractErrorMessage(error);
  //       Swal.fire({
  //         title:
  //           replaceUnderscoresWithSpaces(error?.data?.code) || "Error Occured",
  //         text: capitalize(formattedError),
  //         iconHtml: ` <i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>`,
  //         showCloseButton: true,
  //         customClass: {
  //           icon: "no-border",
  //         },
  //         confirmButtonText: "Try Again",
  //       });
  //     });
  //   // }
  // };
  const handleSubmit = async (values) => {
  // Base profileData
  let profileData = {
    educational_institution_attended: values.educational_institution_attended,
    level_of_education: values.level_of_education,
    field_of_study: values.field_of_study,
    graduation_year: values.graduation_year,
    technical_skill_level: values.technical_skill_level,
    graduation_class: values.graduation_class,
    cv: values.cv,
    linkedin_url: values.linkedin_url,
    english_proficiency: values.english_proficiency,
    other_languages: values.other_languages,
    has_completed_nysc: values?.has_completed_nysc,
  };

  // Add NYSC-related fields only if has_completed_nysc is true
  if (values.has_completed_nysc) {
    profileData = {
      ...profileData,
      nysc_completion_year: values?.nysc_completion_year,
      nysc_certificate: values?.nysc_certificate,
      nysc_certificate_number: values?.nysc_certificate_number,
      nysc_call_up_number: values?.nysc_call_up_number,
    };
  }

  // Remove keys with empty, null, or undefined values
  profileData = Object.fromEntries(
    Object.entries(profileData).filter(
      ([, value]) =>
        value !== "" && value !== null && value !== undefined
    )
  );

  await updateFellowProfile(profileData)
    .unwrap()
    .then(() => {
      toast.success(`✔️ Profile updated !`, {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
      });
      setActiveTab("professional");
    })
    .catch((error) => {
      const formattedError = extractErrorMessage(error);
      Swal.fire({
        title: replaceUnderscoresWithSpaces(error?.data?.code) || "Error Occured",
        text: capitalize(formattedError),
        iconHtml: ` <i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>`,
        showCloseButton: true,
        customClass: { icon: "no-border" },
        confirmButtonText: "Try Again",
      });
    });
};


  const formik = useFormik({
    initialValues: {
      educational_institution_attended:
        currentProfile?.educational_institution_attended || "",
      level_of_education: currentProfile.level_of_education,
      field_of_study: currentProfile?.field_of_study || "",
      graduation_year: currentProfile?.graduation_year || "",
      technical_skill_level: currentProfile?.technical_skill_level || "",
      graduation_class: currentProfile?.graduation_class || "",
      cv: currentProfile?.cv || "",
      linkedin_url: currentProfile?.linkedin_url || "",
      english_proficiency: currentProfile?.english_proficiency || "",
      other_languages: currentProfile?.other_languages || "",

      has_completed_nysc: currentProfile?.has_completed_nysc || false,
      nysc_completion_year: currentProfile?.nysc_completion_year || 1980,
      nysc_certificate: currentProfile?.nysc_certificate || null,
      nysc_certificate_number: currentProfile?.nysc_certificate_number || null,
      nysc_call_up_number: currentProfile?.nysc_call_up_number || null,
    },
    onSubmit: handleSubmit,
    enableReinitialize: true,
    validationSchema: FormSchema,
  });

  // console.log("urrentProfile", currentProfile);

  return (
    <div className="basic-form">
      <h5 className="mb-3">Education and Skills</h5>

      <form
        onSubmit={formik.handleSubmit}
        className={updating ? "disabled" : ""}
      >
        <div className="row g-3">
          <div className="col-md-4">
            <label className="mb-1">
              <strong>Institution Attended</strong>
            </label>
            <input
              id="educational_institution_attended"
              name="educational_institution_attended"
              value={formik.values.educational_institution_attended}
              placeholder="Institution Attended"
              className="form-control"
              {...formik.getFieldProps("educational_institution_attended")}
            />

            {formik.errors.educational_institution_attended ? (
              <div className="text-danger mt-2 fs-12">
                {formik.errors.educational_institution_attended}
              </div>
            ) : null}
          </div>

          <div className="col-md-4">
            <label className="mb-1">
              <strong>Course of Study</strong>
            </label>
            <input
              id="field_of_study"
              name="field_of_study"
              value={formik.values.field_of_study}
              placeholder="Field of Study"
              className="form-control"
              {...formik.getFieldProps("field_of_study")}
            />

            {formik.errors.field_of_study ? (
              <div className="text-danger mt-2 fs-12">
                {formik.errors.field_of_study}
              </div>
            ) : null}
          </div>

          <div className="col-md-4">
            <label className="mb-1">
              <strong>Education Level</strong>
            </label>
            <select
              id="level_of_education"
              name="level_of_education"
              value={formik.values.level_of_education}
              className="form-control"
              onChange={(e) => {
                const selectedEducationLevel = e.target.value;
                formik.setFieldValue(
                  "level_of_education",
                  selectedEducationLevel
                );
                formik.setFieldTouched("level_of_education", true);
              }}
              {...formik.getFieldProps("level_of_education")}
              disabled={
                profielUpdateAllowedFilelds.includes("level_of_education")
                  ? false
                  : true
              }
            >
              <option value="">Select Education</option>;

              {EducationData.map((education) => {
                return <option value={education}>{education}</option>;
              })}
            </select>
            {formik.errors.level_of_education ? (
              <div className="text-danger mt-2 fs-12">
                {formik.errors.level_of_education}
              </div>
            ) : null}
          </div>

          <div className="col-md-4">
            <label className="mb-1">
              <strong>Year of Graduation</strong>
            </label>
            <select
              id="graduation_year"
              name="graduation_year"
              value={formik.values.graduation_year}
              className="form-control"
              onChange={(e) => {
                const selectedSkill = e.target.value;
                formik.setFieldValue("graduation_year", selectedSkill);
              }}
              {...formik.getFieldProps("graduation_year")}
            >
              <option value="">Select Year</option>;
              {fullYears.map((skill) => {
                return <option value={skill}>{skill}</option>;
              })}
            </select>
            {formik.errors.graduation_year ? (
              <div className="text-danger mt-2 fs-12">
                {formik.errors.graduation_year}
              </div>
            ) : null}
          </div>

          <div className="col-md-4">
            <label className="mb-1">
              <strong>Graduation Class</strong>
            </label>
            <select
              id="graduation_class"
              name="graduation_class"
              value={formik.values.graduation_class}
              className="form-control"
              onChange={(e) => {
                const selectedSkill = e.target.value;
                formik.setFieldValue("graduation_class", selectedSkill);
              }}
              {...formik.getFieldProps("graduation_class")}
            >
              {GraduationClassOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {formik.errors.graduation_class ? (
              <div className="text-danger mt-2 fs-12">
                {formik.errors.graduation_class}
              </div>
            ) : null}
          </div>

          <div className="col-md-4  form-balance">
            <label className="mb-1">
              <strong>Have you completed NYSC?</strong>
            </label>
            <div className="d-flex align-items-center justify-content-between ">
              {options.map((item, index) => {
                return (
                  <button
                    key={index}
                    type="button"
                    className={`btn btn-outline-grey flex-grow me-2 ${
                      formik?.values?.has_completed_nysc === item?.value
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      formik.setFieldValue("has_completed_nysc", item?.value);
                    }}
                  >
                    {item?.label}
                  </button>
                );
              })}
            </div>
          </div>

          {formik.values?.has_completed_nysc && (
            <Fragment>
              <div className="col-md-4">
                <label className="mb-1">
                  <strong>Nysc Completion Year</strong>
                </label>
                <select
                  id="nysc_completion_year"
                  name="nysc_completion_year"
                  value={formik.values.nysc_completion_year}
                  className="form-control"
                  onChange={(e) => {
                    const selectedSkill = e.target.value;
                    formik.setFieldValue("nysc_completion_year", selectedSkill);
                  }}
                  {...formik.getFieldProps("nysc_completion_year")}
                >
                  {fullYears.map((skill) => {
                    return <option value={skill}>{skill}</option>;
                  })}
                </select>
                {formik.errors.nysc_completion_year ? (
                  <div className="text-danger mt-2 fs-12">
                    {formik.errors.nysc_completion_year}
                  </div>
                ) : null}
              </div>

              <div className="col-md-4">
                <label className="mb-1">
                  <strong>NYSC Certificate ID</strong>
                </label>
                <input
                  id="nysc_certificate_number"
                  name="nysc_certificate_number"
                  value={formik.values.cv}
                  placeholder="Please share the URL to your CV"
                  className="form-control"
                  {...formik.getFieldProps("nysc_certificate_number")}
                />
                {formik.errors.nysc_certificate_number ? (
                  <div className="text-danger mt-2 fs-12">
                    {formik.errors.nysc_certificate_number}
                  </div>
                ) : null}
              </div>

              <div className="col-md-4">
                <label className="mb-1">
                  <strong>Nysc Callup-Number</strong>
                </label>
                <input
                  id="nysc_call_up_number"
                  name="nysc_call_up_number"
                  value={formik.values.nysc_call_up_number}
                  placeholder="Nysc callup number"
                  className="form-control"
                  {...formik.getFieldProps("nysc_call_up_number")}
                />
                {formik.errors.nysc_call_up_number ? (
                  <div className="text-danger mt-2 fs-12">
                    {formik.errors.nysc_call_up_number}
                  </div>
                ) : null}
              </div>

              <div className="col-md-4">
                <label className="mb-1">
                  <strong>Please share the URL to your NYSC certificate</strong>
                </label>
                <input
                  id="nysc_certificate"
                  name="nysc_certificate"
                  value={formik.values.nysc_certificate}
                  placeholder="Please share the URL to your NYSC certificate"
                  className="form-control"
                  {...formik.getFieldProps("nysc_certificate")}
                />
                {formik.errors.nysc_certificate ? (
                  <div className="text-danger mt-2 fs-12">
                    {formik.errors.nysc_certificate}
                  </div>
                ) : null}
              </div>
            </Fragment>
          )}

          <div className="col-md-4">
            <label className="mb-1">
              <strong>Please share the URL to your CV</strong>
            </label>
            <input
              id="cv"
              name="cv"
              value={formik.values.cv}
              placeholder="Please share the URL to your CV"
              className="form-control"
              {...formik.getFieldProps("cv")}
            />
            {formik.errors.cv ? (
              <div className="text-danger mt-2 fs-12">{formik.errors.cv}</div>
            ) : null}
          </div>

          <div className="col-md-4">
            <label className="mb-1">
              <strong>Please share the url to your LinkedIn profile.</strong>
            </label>
            <input
              id="linkedin_url"
              name="linkedin_url"
              value={formik.values.linkedin_url}
              placeholder="Please share the url to your LinkedIn profile."
              className="form-control"
              {...formik.getFieldProps("linkedin_url")}
            />
            {formik.errors.linkedin_url ? (
              <div className="text-danger mt-2 fs-12">
                {formik.errors.linkedin_url}
              </div>
            ) : null}
          </div>
        </div>

        <div className="row g-3">
          <div className="row g-3">
            <div className="col-md-12">
              <label className="mb-3">
                <strong>Skill Level</strong>
              </label>
              <div className="d-flex align-items-center justify-content-between mb-3">
                {levels.map((item, index) => {
                  return (
                    <button
                      key={index}
                      type="button"
                      className={`btn btn-outline-grey ${
                        formik?.values?.technical_skill_level === item
                          ? "active"
                          : "d"
                      } flex-grow me-2 `}
                      onClick={() => {
                        formik.setFieldValue("technical_skill_level", item);
                      }}
                    >
                      {item}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div className="row g-3 mb-3">
          <div className="col-md-4">
            <label className="mb-1">
              <strong>English Proficiency</strong>
            </label>
            <select
              id="english_proficiency"
              name="english_proficiency"
              value={formik.values.english_proficiency}
              className="form-control"
              onChange={(e) => {
                const selectedEnglishProficiency = e.target.value;
                formik.setFieldValue(
                  "english_proficiency",
                  selectedEnglishProficiency
                );
              }}
              {...formik.getFieldProps("english_proficiency")}
            >
              {EnglishProficiencyLevelOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {formik.errors.english_proficiency ? (
              <div className="text-danger mt-2 fs-12">
                {formik.errors.english_proficiency}
              </div>
            ) : null}
          </div>

          <div className="col-md-4">
            <label className="mb-1">
              <strong>Other Languages</strong>
            </label>
            <input
              id="other_languages"
              name="other_languages"
              value={formik.values.other_languages}
              placeholder="Enter a list of all the other languages you speak if any"
              className="form-control"
              {...formik.getFieldProps("other_languages")}
            />
            {formik.errors.other_languages ? (
              <div className="text-danger mt-2 fs-12">
                {formik.errors.other_languages}
              </div>
            ) : null}
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <button
            onClick={() => setActiveTab("personal")}
            type="button"
            className="submit btn btn-outline-grey  me-2"
          >
            Back
          </button>

          <button
            type="submit"
            className="submit btn btn-pigment-green"
            disabled={updating || !formik.dirty}
          >
            {updating ? (
              <span
                role="button"
                aria-hidden="true"
                className="spinner-border spinner-border-sm ms-2"
              ></span>
            ) : (
              "Save & Proceed"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Education;

const FormSchema = Yup.object().shape({
  educational_institution_attended: Yup.string().nullable(),
  // .required("Institution is required"),

  field_of_study: Yup.string().nullable(),
  // .required("Field of Study is required"),

  level_of_education: Yup.string().nullable(),
  // .required("Education is required"),

  graduation_year: Yup.string()
    .matches(/^\d{4}$/, "Graduation year must be exactly 4 numbers")
    .nullable(),
    // .required("Graduation year is required"),

  technical_skill_level: Yup.string().nullable(),
  // .required("Technical Skill level is required"),

  graduation_class: Yup.string().nullable(),
  // .required("Graduation class is required"),

  cv: Yup.string()
    .url("Enter a valid URL")
    .nullable(),
  // .required("CV is required"),

  linkedin_url: Yup.string()
    .url("Enter a valid URL")
    .nullable(),
  // .required("Your LinkedIn profile is required"),

  english_proficiency: Yup.string().nullable(),
  // .required("Please select your English proficiency level"),

  other_languages: Yup.string().nullable(),
  // .required("Other languages required"),

  has_completed_nysc: Yup.boolean().nullable(),
  // .required("Tell us your NYSC status"),

  nysc_completion_year: Yup.string().when("has_completed_nysc", {
    is: (has_completed_nysc) => has_completed_nysc,
    then: () => Yup.string().nullable(),
    // .required("This option is required"),
    otherwise: () => Yup.string().nullable(),
  }),

  nysc_certificate: Yup.string().when("has_completed_nysc", {
    is: (has_completed_nysc) => has_completed_nysc,
    then: () => Yup.string().nullable(),
    // .required("NYSC certificate url is required"),
    otherwise: () => Yup.string().nullable(),
  }),

  nysc_certificate_number: Yup.string().when("has_completed_nysc", {
    is: (has_completed_nysc) => has_completed_nysc,
    then: () => Yup.string().nullable(),
    // .required("This option is required"),
    otherwise: () => Yup.string().nullable(),
  }),

  nysc_call_up_number: Yup.string().when("has_completed_nysc", {
    is: (has_completed_nysc) => has_completed_nysc,
    then: () => Yup.string().nullable(),
    // .required("This option is required"),
    otherwise: () => Yup.string().nullable(),
  }),
});

